module.exports = __webpack_public_path__ + "img/4.5da91984.png";